export default "__VITE_ASSET__82bff7cd__"